<template>
  <div class="auth-page">
    <div class="auth-page__bg"></div>
    <div class="auth-page__card">
      <img src="/logo.png" alt="Palace of Kebap" class="auth-page__logo" />
      <h2 class="auth-page__title">Account erstellen</h2>
      <p class="auth-page__sub">Für schnellere Bestellungen</p>

      <form @submit.prevent="onRegister">
        <div class="auth-input">
          <feather-icon icon="UserIcon" svgClasses="w-5 h-5" />
          <input
            type="text"
            placeholder="Vor- und Nachname"
            v-model="name"
            required
          />
        </div>
        <div class="auth-input">
          <feather-icon icon="MailIcon" svgClasses="w-5 h-5" />
          <input type="email" placeholder="E-Mail" v-model="email" required />
        </div>
        <div class="auth-input">
          <feather-icon icon="LockIcon" svgClasses="w-5 h-5" />
          <input
            :type="showPw ? 'text' : 'password'"
            placeholder="Passwort"
            v-model="password"
            required
          />
          <feather-icon
            :icon="showPw ? 'EyeOffIcon' : 'EyeIcon'"
            svgClasses="w-5 h-5 cursor-pointer"
            @click="showPw = !showPw"
          />
        </div>
        <div class="auth-input">
          <feather-icon icon="LockIcon" svgClasses="w-5 h-5" />
          <input
            :type="showPw ? 'text' : 'password'"
            placeholder="Passwort wiederholen"
            v-model="confirm_password"
            required
          />
        </div>

        <label
          class="flex items-center mb-4 cursor-pointer"
          style="color: #999; font-size: 13px"
        >
          <input
            type="checkbox"
            v-model="isTermsAccepted"
            style="margin-right: 8px"
          />
          <span>Datenschutzbedingungen akzeptieren</span>
          <span
            style="color: #c41e2a; margin-left: 8px; cursor: pointer"
            @click.prevent="showPrivacy = true"
            >Lesen</span
          >
        </label>

        <button
          type="submit"
          class="auth-btn auth-btn--primary"
          :disabled="!validateForm"
        >
          Registrieren
        </button>
        <button
          type="button"
          class="auth-btn auth-btn--secondary"
          @click="$router.push('/pages/login')"
        >
          Anmelden
        </button>
        <button
          type="button"
          class="auth-btn auth-btn--outline"
          @click="$router.push('/')"
        >
          Als Gast bestellen
        </button>
      </form>
    </div>

    <vs-popup
      fullscreen
      title="Datenschutzerklärung"
      :active.sync="showPrivacy"
    >
      <privacy-statement></privacy-statement>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      confirm_password: "",
      isTermsAccepted: false,
      showPw: false,
      showPrivacy: false,
    };
  },
  computed: {
    validateForm() {
      return (
        this.name &&
        this.email &&
        this.password &&
        this.confirm_password &&
        this.isTermsAccepted
      );
    },
  },
  methods: {
    ...mapActions({ register: "auth/register" }),
    onRegister() {
      if (this.password !== this.confirm_password) {
        this.$vs.notify({
          title: "Fehler",
          text: "Passwörter stimmen nicht überein",
          color: "danger",
          position: "top-center",
        });
        return;
      }
      this.register({
        name: this.name,
        email: this.email,
        password: this.password,
      })
        .then(() => {
          this.$vs.dialog({
            color: "success",
            title: "Willkommen, " + this.name + "!",
            text: "Gib deine Adresse an, damit du diese nicht bei jeder Bestellung neu eingeben musst!",
            accept: () => this.$router.replace({ name: "profil" }),
            acceptText: "Verstanden",
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fehler",
            text: "Registrierung fehlgeschlagen",
            color: "danger",
            position: "top-center",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/auth.scss";

.auth-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
